import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../unsorted/index4.js';
import { _ as _slicedToArray } from '../unsorted/slicedToArray.js';
import { useRef, useState, useEffect } from 'react';
import { fetchLogoContent } from '../utils/svgHelpers.js';
import { usePrevious } from './usePrevious.js';
import { useUpdateEffect } from './useUpdateEffect.js';

function useFetchLogoContent(logo) {
  var isFetching = useRef(false);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    svgContent = _useState2[0],
    setSvgContent = _useState2[1];
  var previousLogo = usePrevious(logo);
  useEffect(function () {
    function fetchContent() {
      return _fetchContent.apply(this, arguments);
    } // @NOTE: ONLY fetch the icon content if it hasn't already been fetched
    function _fetchContent() {
      _fetchContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var content;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isFetching.current = true;
              _context.next = 3;
              return fetchLogoContent(logo);
            case 3:
              content = _context.sent;
              if (content) setSvgContent(content);
              isFetching.current = false;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _fetchContent.apply(this, arguments);
    }
    if (!svgContent && !isFetching.current) fetchContent();
  }, [logo, svgContent]);
  useUpdateEffect(function () {
    if (previousLogo !== logo) setSvgContent(null);
  }, [logo, previousLogo]);
  return svgContent;
}

export { useFetchLogoContent };
//# sourceMappingURL=useFetchLogoContent.js.map
